import { Parchment } from 'quill/core';

class SoftBreak extends Parchment.ClassAttributor {
  value(node: HTMLElement) {
    return !!super.value(node);
  }
}

export default new SoftBreak('soft', 'ql-soft', {
  scope: Parchment.Scope.BLOCK_ATTRIBUTE,
});
